
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'NewEmptyPackage',
  data(): {
    showButtons: boolean;
    editedName: string;
  } {
    return {
      showButtons: false,
      editedName: ''
    };
  },
  props: {
    onInputSave: {
      type: Function as PropType<(name: string) => void>,
      required: false,
      default: (name: string) => {}
    },
    onDelete: {
      type: Function as PropType<() => void>,
      required: false,
      default: () => {}
    },
    editing: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    submitInput() {
      this.onInputSave(this.editedName);
      this.editedName = '';
    }
  },
  watch: {}
});
